/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 22:05:38
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-10-18 22:41:35
 */
const STATUS = {
  1: "待入驻",
  2: "已入驻",
};
const STATUSTYPE = {
  3: "删除",
};
export default (Vue) => {
  return [
    {
      title: "姓名",
      key: "realName",
      minWidth: 160,
      align: "center",
    },
    {
      title: "手机号",
      key: "phone",
      align: "center",
      minWidth: 170,
    },
    {
      title: "身份证",
      key: "idNumber",
      align: "center",
      minWidth: 170,
    },
    {
      title: "所属公司",
      key: "companyName",
      align: "center",
      minWidth: 170,
    },
    {
      title: "入驻时间",
      key: "createDt",
      minWidth: 180,
      align: "center",
    },
    {
      title: "审核状态",
      key: "reviewStatus",
      align: "center",
      minWidth: 120,
      render: (h, { row }) => {
        const map = { 0: "待审核", 2: "通过", 3: "不通过" };
        const color =
          String(row.reviewStatus) === "2"
            ? "success"
            : String(row.reviewStatus) === "3"
            ? "error"
            : "warning";
        return h("Tag", { props: { color } }, map[row.reviewStatus] || "-");
      },
    },
    {
      title: "接单状态",
      key: "isAcceptOrders",
      align: "center",
      minWidth: 120,
      render: (h, { row }) => {
        const isAccept =
          String(row.isAcceptOrders) === "1" || row.isAcceptOrders === "";
        const color = isAccept ? "success" : "default";
        return h("Tag", { props: { color } }, isAccept ? "能" : "不能");
      },
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      align: "center",
      width: 220,
      render: (h, { row }) => {
        const buttons = [];

        // 审核按钮，只有 reviewStatus = 0 时才显示
        if (String(row.reviewStatus) === "0") {
          buttons.push(
            h(
              "Button",
              {
                props: {
                  type: "text",
                  size: "small",
                },
                style: {
                  color: "#3091FF",
                },
                on: {
                  click: () => {
                    Vue.reviewFormData = {
                      id: row.id,
                      userId: row.userId,
                      type: "2",
                      reviewStatus: "",
                    };
                    Vue.showReviewDialog = true;
                  },
                },
              },
              "审核",
            ),
          );
        }

        // 接单审核/切换按钮
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
                marginLeft: "8px",
              },
              on: {
                click: () => {
                  const next =
                    String(row.isAcceptOrders) === "1" ||
                    row.isAcceptOrders === ""
                      ? "0"
                      : "1";
                  const text = next === "1" ? "能接单" : "不能接单";
                  Vue.$confirm(`确认设置为${text}?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                    .then(async () => {
                      const id = row.id || row.userId;
                      await Vue.$post("/user/updateIsAcceptOrders", {
                        id,
                        isAcceptOrders: next,
                      });
                      Vue.$Notice.success({ title: "更新成功" });
                      Vue.getCleanerList();
                    })
                    .catch(() => {});
                },
              },
            },
            "接单审核",
          ),
        );

        // 编辑按钮
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  Vue.formData = row;
                  Vue.showNewDialog = true;
                },
              },
            },
            "编辑",
          ),
        );

        // 删除按钮
        buttons.push(
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  Vue.$confirm("确认删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                    .then(async () => {
                      await Vue.$post("/user/delete", { userIds: row.userId });
                      Vue.$Notice.success({ title: "删除成功" });
                      Vue.getCleanerList();
                    })
                    .catch(() => {
                      this.$message({
                        type: "info",
                        message: "已取消删除",
                      });
                    });
                },
              },
            },
            "删除",
          ),
        );

        return h("div", buttons);
      },
    },
  ];
};
